"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var container = _7a468({
  defaultClassName: "Spinner_container__1qs92ss2",
  variantClassNames: {
    primary: {
      true: "Spinner_container_primary_true__1qs92ss3"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var element = "Spinner_element__1qs92ss4";
export var message = "Spinner_message__1qs92ss6";
export var path = "Spinner_path__1qs92ss5";
export var spinnerVars = {
  color: "var(--color__1qs92ss0)"
};